import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import LazyAnimation from './LazyAnimation';

const useStyles = makeStyles({
  container: {
    marginBottom: '9%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  wrapper: {
    width: '100%',
    zIndex: 1,
  },
  header: {
    cursor: 'pointer',
    color: '#FFFFFF',
    width: '100%',
    position: 'relative',
    fontSize: 16,
    fontFamily: 'MontserratSemiBold',
    fontWeight: '600',
    textTransform: 'uppercase',
    transition: 'all 600ms ease 0ms',
    '& > svg': {
      position: 'absolute',
      height: 16,
      width: 16,
      color: '#CCCCCC',
      right: 0,
    },
  },
  headerOpen: {
    color: '#000000',
  },
  list: {
    width: '100%',
    backgroundColor: '#B3B3B3',
    padding: 20,
    transition: 'all 600ms ease 0ms',
    overflow: 'hidden',
  },
  listOpen: {
    height: 'auto',
    backgroundColor: '#FFFFFF',
  },
  listItem: {
    color: '#666666',
    fontFamily: 'OpenSansRegular',
    lineHeight: '26px',
    listStyleType: 'disc',
    fontSize: 14,
  },
  box: {
    maxHeight: 0,
    height: 0,
    transition: 'all 600ms ease 0ms',
    transformOrigin: 'top left',
    overflow: 'hidden',
  },
  boxOpen: {
    maxHeight: 1500,
    height: 'auto',
    '& > ul': {
      padding: 0,
      paddingLeft: 16,
    },
  },
});

function ThemeList({ theme }) {
  const classes = useStyles();
  const [isOpen, setOpen] = useState(false);

  const handleClick = () => setOpen(!isOpen);

  return (
    <LazyAnimation type="translate-left-200 fade-in">
      <div className={classes.container}>
        <div className={classes.wrapper}>
          <div
            className={_classNames({
              [classes.list]: true,
              [classes.listOpen]: isOpen,
            })}
          >
            <Typography
              className={_classNames({
                [classes.header]: true,
                [classes.headerOpen]: isOpen,
              })}
              onClick={handleClick}
              role="button"
              tabIndex={0}
            >
              {`${theme.title} `}
              {isOpen ? <RemoveCircleIcon /> : <AddCircleIcon />}
            </Typography>
            <div
              className={_classNames({
                [classes.box]: true,
                [classes.boxOpen]: isOpen,
              })}
            >
              <ul>
                {theme.list.map(topic => (
                  <li key={topic}>
                    <Typography className={classes.listItem}>
                      {topic}
                    </Typography>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </LazyAnimation>
  );
}

ThemeList.propTypes = {
  theme: PropTypes.object,
};

export default ThemeList;
